import { useEffect } from "react";
import { Box } from "@mui/material";
import { observer } from "mobx-react-lite";

import { Stack } from "@mui/system";

import store from "../../mobx";
import { DotGridCluster } from "../../components/Pizazz/DotGridBorder";

import { NavRail } from "../../components/NavRail";
import { ValueProp } from "./ValueProp";
import { FeaturesCarousel } from "./FeaturesCarousel";
import { Testimonials } from "./Testimonials";
import { Socials } from "./Socials";
import { KeyboardArrowDown } from "@mui/icons-material";

export default observer(function MixQuickProductPage() {
  const { isPhone } = store.mediaBreakpointStore;

  useEffect(() => {
    store.appBarStore.set.hidden(true);
    return () => store.appBarStore.set.hidden(false);
  }, []);

  const sectionSpacing = isPhone ? 4 : 8;

  const dotSpacing = isPhone ? 2.5 : 3.75;

  const titleSpacing = isPhone ? 3 : 5;

  const section2Items = [
    {
      component: <ValueProp />,
      sx: { height: "100vh" },
      disableDivider: true,
    },
    {
      component: <FeaturesCarousel title="Features" spacing={5} />,
      spacing: isPhone ? 2 : undefined,
      sx: { height: "calc(100vh)" },
    },
    {
      component: <Testimonials spacing={titleSpacing} />,
      disableArrow: true,
    },
    {
      component: (
        <Socials
          title="Speed me up!"
          titleProps={
            isPhone
              ? {
                  sx: {
                    fontSize: 34,
                  },
                }
              : undefined
          }
          spacing={isPhone ? 3.5 : 4.5}
        />
      ),
      spacing: isPhone ? 2 : 3.25,
      disableArrow: true,

      // sx: { pb: 1 },
    },
  ];

  return (
    <Stack
      sx={{
        backgroundImage: `url('main_background6.jpg')`,
        backgroundPosition: `left 50px`, // ✅ Shifts the image down by 50px
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover", // Optional: ensures full coverage
        width: "100vw",
        overflowX: "hidden",
        overflowY: "scroll",
      }}
    >
      <NavRail />

      <Stack spacing={sectionSpacing}>
        {section2Items.map(
          (
            { component, spacing, sx, disableDivider, disableArrow, arrowSx },
            index
          ) => {
            return (
              <Stack
                id={`section-${index + 1}`}
                key={index}
                index={index}
                spacing={spacing || dotSpacing}
                sx={{
                  position: "relative", // Important for arrow positioning
                  ...sx,
                }}
              >
                {!disableDivider && (
                  <DotLine
                    direction={index % 2 === 0 ? "right" : "left"}
                    speedMs={
                      index === section2Items.length - 1 ? 750 : undefined
                    }
                  />
                )}

                {component}

                {!disableArrow && (
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: 30,
                      left: "50%",
                      transform: "translateX(-50%)",
                      zIndex: 100,
                    }}
                  >
                    <KeyboardArrowDown
                      sx={{
                        width: 60,
                        height: 60,
                        color: "secondary.light",
                        borderRadius: 15,
                        WebkitTapHighlightColor: "transparent",
                        cursor: "pointer",
                        "&:hover": {
                          bgcolor: "#fff1",
                        },
                        ...arrowSx,
                      }}
                      onClick={() => {
                        const section2 = document.getElementById(
                          `section-${index + 2}`
                        );
                        section2?.scrollIntoView({ behavior: "smooth" });
                      }}
                    />
                  </Box>
                )}
              </Stack>
            );
          }
        )}
      </Stack>
    </Stack>
  );
});

function DotLine({ direction = "left", speedMs = 1000 }) {
  return (
    <Box sx={{ pt: 1 }}>
      <DotGridCluster
        reverseVertical
        alternate
        number={2}
        dotSize={8}
        dotColor={"#fff3"}
        direction={direction}
        speedMs={speedMs}
        speedOffset={20}
        animationOffset={0}
        sx={{
          height: 16,
        }}
      />
    </Box>
  );
}
